import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import ListRegulation from './ListRegulation'

import EditRegulation from './EditRegulation'
import NewRegulation from './NewRegulation'

const SpecialistRegulationRoutes = () => {

  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListRegulation /></PrivateRoute7>} />
        <Route path="edit-regulation" element={<PrivateRoute7><EditRegulation /></PrivateRoute7>} />
        <Route path="new-regulation" element={<PrivateRoute7><NewRegulation /></PrivateRoute7>} />
    </Routes>
  )
}

export default SpecialistRegulationRoutes